const prefix = '/api';

const api = {
  getBannerList: `${prefix}/banner/list`,
  getPopupList: `${prefix}/popup/list`
};

export default {
  ...api
};
